const SFP_BTN_STATUSES = {
  initial: 'initial',
  pending: 'pending',
  error: 'error',
};

const SFP_PROCESS_STATUSES = {
  inProgress: 'InProgress',
  error: 'Error',
  complete: 'Complete',
};

const SFP_PROCESS_STEPS = {
  initial: 'initial',
  success: 'success',
  timeout: 'timeout',
};

const API_ENDPOINTS = {
  requestInfo: '/sbpapi/',
  postPaymentData: '/sbpapi/payment/',
  fetchPaymentData: '/sbpapi/payment-status/',
};

const SPF_TEXT_CONFIG = {
  error: 'Ничего не найдено',
  spfButtonText: 'Оплатить через',
};

export {
  SFP_BTN_STATUSES,
  SFP_PROCESS_STATUSES,
  SFP_PROCESS_STEPS,
  API_ENDPOINTS,
  SPF_TEXT_CONFIG,
};
